// my plugins can get data from events of this module!
var globalevents_controller = {
	triggerNewProjectPageLayoutObj: function (layoutObj) {
		window.laytheme.emit('newprojectpagelayoutobj', layoutObj)
	},
	triggerProjectPageShown: function () {
		window.laytheme.emit('projectpageshown')
	},
	triggerNewPage: function (layoutObj, type, obj) {
		window.laytheme.emit('newpage', layoutObj, type, obj)
	},
	triggerNewPageShown: function (layoutObj, type, obj, isProjectOverlayObj) {
		window.laytheme.emit('newpageshown', layoutObj, type, obj, isProjectOverlayObj)
		window.laytheme.emit('newpageshownfast', layoutObj, type, obj, isProjectOverlayObj)
	},
	triggerSwitchedDesktopLayoutToCustomPhoneLayout: function () {
		window.laytheme.emit('switched_desktoplayout_to_customphonelayout')
	},
	triggerSwitchedCustomPhoneLayoutToDesktopLayout: function () {
		window.laytheme.emit('switched_customphonelayout_to_desktoplayout')
	},
	triggerGridShown: function (gridObj, targetRegion, type, obj) {
		window.laytheme.emit('gridshown', gridObj, targetRegion, type, obj)
	},
	triggerSizeChanged: function (size) {
		window.laytheme.emit('sizechanged', size)
	},
	triggerPushState: function () {
		window.laytheme.emit('pushstate')
	},
}

export default globalevents_controller
